module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-desktop-ru.601cadbc.jpg";